module.exports = __webpack_public_path__ + "media/images/logo-outings-text-0647acf34c3d61123a98bac4854c98f5.png";